<p>ot-schedule-upload-details works!</p>
